import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  AddTopcondition,
  DeleteTopcondition,
  GetTopconditionDetails,
  UpdateTopcondition,
} from "../../../../api/User/ACG/ConditionCategoryApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  gender: Yup.string()
    .notOneOf(["Select Gender"], "Please select gender")
    .required("Please select gender"),
  clinical_Condition: Yup.string().required("Please enter clinical condition"),
  prevalence_Rate: Yup.number()
    .min(0, "Number must be positive")
    .typeError("Please enter a valid number")
    .required("Please enter prevalence rate"),
  est_PMPY: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter est PMPY"),
});

const ConditionCategory = () => {
  const [data, setData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const buttonRef = useRef(null);

  const column = [
    {
      title: "Gender",
      field: "gender",
    },
    {
      title: "Clinical Condition Category",
      field: "clinical_Condition",
    },
    {
      title: "Prevalence Rate",
      field: "prevalence_Rate",
      render: (rowData) => (+rowData.prevalence_Rate * 100).toFixed(2)+ "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.prevalence_Rate  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
    {
      title: "Est PMPY",
      field: "est_PMPY",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    GetTopconditionDetails()
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { gender, clinical_Condition, prevalence_Rate, est_PMPY } = values;
    const payload = {
      id: 0,
      gender,
      clinical_Condition,
      prevalence_Rate: +prevalence_Rate,
      est_PMPY: +est_PMPY,
    };

    if (witchAction === "add") {
      AddTopcondition(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("new");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      UpdateTopcondition(selectedRowData.id, {
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("update");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Condition Category
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteTopcondition(selectedRowData?.id).then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                gender: selectedRowData?.gender ?? "Select Gender",
                clinical_Condition: selectedRowData?.clinical_Condition,
                prevalence_Rate: selectedRowData?.prevalence_Rate ?? 0,
                est_PMPY: selectedRowData?.est_PMPY ?? 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <div className="text-wrap">
                      Are you sure that you want to delete the record?
                    </div>
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <Form.Group>
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Gender <Required />
                          </Form.Label>
                          <Form.Select
                            className="rounded-0"
                            style={Fontstyling.label}
                            name="gender"
                            onChange={handleChange}
                            value={values.gender}
                            isInvalid={
                              values.gender === "Select Gender" &&
                              touched.gender
                            }
                          >
                            <option value={"Select Gender"}>
                              Select Gender
                            </option>
                            {["F", "M"].map((item, index) => (
                              <option
                                value={item}
                                selected={selectedRowData?.gender === item}
                              >
                                {item}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select gender
                          </Form.Control.Feedback>
                        </Form.Group>
                        <CustomInputField
                          label="Clinical Condition Category"
                          name="clinical_Condition"
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                        />
                        <CustomInputField
                          label="Prevalence Rate"
                          name="prevalence_Rate"
                          maxLength={10}
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                        />
                        <CustomInputField
                          label="Est PMPY"
                          name="est_PMPY"
                          maxLength={10}
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                        />
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add Condition Category
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
      />
    </div>
  );
};

export default ConditionCategory;
